// =============================================================================
// DeliveryInstruction.jsx — the "Delivery Instructions" line on the picker views.
// =============================================================================
// Shows the delivery address's instruction (e.g. "Open Monday to Thursday - 9am to
// 3pm") so a picker sees it without the caseworker having to retype it (Helen,
// 5 Nov 2026). The text comes from the Sales Order header the picker view already
// loads — request_sales_orders.delivery_instruction, copied from the delivery address
// at Confirm & Send (salesOrderCreation / topUpSalesOrderCreation) — so it is exactly
// what Unleashed receives. An address edited after Confirm & Send is NOT reflected on
// an order that already exists (same as Unleashed).
//
// Renders nothing when the text is blank.
//
// Props
//   text   — the instruction (string | null | undefined)
//   layout — "row" (label left, value right: PickerRequestView's General Information
//            rows) or "stacked" (label above: TopUpPickerView). Default "row".
// =============================================================================

export function DeliveryInstruction({ text, layout = "row" }) {
  const value = typeof text === "string" ? text.trim() : "";
  if (!value) return null;
  const stacked = layout === "stacked";
  return (
    <div className={stacked ? "mt-2.5" : "mt-2.5 flex items-start"}>
      <div
        className={
          stacked
            ? "mb-1 text-[11px] font-bold uppercase tracking-[0.4px] text-zephyr-muted"
            : "w-[120px] shrink-0 pt-[7px] text-[11px] font-bold uppercase tracking-[0.4px] text-zephyr-muted"
        }
      >
        Delivery Instructions
      </div>
      <div className="flex flex-1 items-start gap-2 rounded-[7px] border border-zephyr-gold bg-zephyr-gold-light px-2.5 py-[7px]">
        <svg
          aria-hidden="true"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mt-0.5 shrink-0 text-zephyr-orange"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
        <div className="whitespace-pre-wrap text-[13px] font-semibold leading-[1.45] text-zephyr-text">
          {value}
        </div>
      </div>
    </div>
  );
}
